import { SignDocValidationResultType } from '../../services/documents/ts/enums';
import { SignDocError, SignDocResult } from '../../services/documents/ts/types';

import { buildValidatedDocsMap } from './utils';

export const isResultInvalid = (item: SignDocResult) =>
    item.validation !== SignDocValidationResultType.OK;

export const signMultiDocsValidationErrors = (results) => {
    const filteredResults = results.filter(isResultInvalid);

    return buildValidatedDocsMap(filteredResults);
};

// Errors from server
export const signMultiDocsOtherErrors = (results) =>
    results.filter((item): item is SignDocError => Boolean(item.error));
